import React, { useState } from 'react';

export default function LocationPicker({ onSaveLocation }) {
  const [showMap, setShowMap] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("share");
  const [isAddLocationOpen, setAddLocationOpen] = useState(false);
  const [showDistanceModal, setShowDistanceModal] = useState(false);

  const toggleModal = () => setModalOpen(!isModalOpen);
  const toggleAddLocationModal = () => setAddLocationOpen(!isAddLocationOpen);
  const toggleDistanceModal = () => setShowDistanceModal(!showDistanceModal);

  const handleSave = () => {
    const country = "Default Country";
    setSelectedCountry(country);
    if (typeof onSaveLocation === 'function') onSaveLocation(country);
    setShowMap(false);
  };

  return (
    <div className="w-full mt-2 rounded-md">
      <div className="relative mt-4">
        {/* Floating Box - Mobile (ONLY this changed) */}
        <div className="md:hidden absolute top-2 right-2 flex items-start gap-1 bg-[#E7EBEB] rounded-[3px] w-[100px] h-[70px] p-1 text-[8px] font-normal shadow-md z-40">
          <div className="flex-1 space-y-1 leading-tight">
            <p onClick={toggleModal}>Coordinates -25.96669.28.04804 Share this location</p>
            <p onClick={toggleAddLocationModal}>Add location</p>
            <p onClick={toggleDistanceModal}>Measure distance</p>
          </div>
        </div>

        {/* Floating Box - Desktop (UNCHANGED) */}
        <div className="hidden md:block absolute top-10 right-4 md:top-28 md:right-72 flex items-start gap-2 bg-[#E7EBEB] rounded-[5px] w-[180px] h-[220px] md:w-[222px] md:h-[240px] p-3 md:p-4 text-[14px] md:text-[19px] font-normal shadow-md z-40">
          <div className="flex-1 space-y-4 md:space-y-8 leading-tight">
            <p onClick={toggleModal}>Coordinates -25.96669.28.04804 Share this location</p>
            <p onClick={toggleAddLocationModal}>Add location</p>
            <p onClick={toggleDistanceModal}>Measure distance</p>
          </div>
        </div>

        {/* Icon - Mobile (smaller only on mobile) */}
        <img
          src='https://res.cloudinary.com/dzngpgki4/image/upload/v1747086696/image_1737_lmlxuu.png'
          alt='map pin'
          className='w-8 h-8 md:w-[128px] md:h-[128px] absolute top-1 right-52 md:top-2 md:right-4 md:right-[480px] z-40'
        />
      </div>

      {/* Map Image (UNCHANGED) */}
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747086565/image_2_juwt4n.png"
        alt="Click to select location" 
        className="rounded-md w-full h-auto object-cover mt-4 cursor-pointer"
        onClick={() => setShowMap(true)}
      />

      {/* Share/Embed Modal - Mobile adjustments ONLY */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-[#E7EBEB] w-[90%] max-w-[700px] md:w-[640px] h-[250px] md:h-[422px] rounded-md relative shadow-lg p-3 md:p-12">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747088705/Dell_duotone_pdjxuz.png"
              alt="close"
              className="absolute top-2 right-2 md:top-4 md:right-4 w-4 h-4 md:w-8 md:h-8 cursor-pointer"
              onClick={toggleModal}
            />
            <h2 className="text-[14px] md:text-[24px] font-bold mb-2 md:mb-4">
              {activeTab === "share" ? "Share" : "Embed a map"}
            </h2>
            <div className="flex justify-between mb-3 md:space-x-64 md:mb-8 text-[12px] md:text-[19px] font-medium">
              <button onClick={() => setActiveTab("share")}>Share</button>
              <button onClick={() => setActiveTab("embed")}>Embed a map</button>
            </div>
            <div className="flex mb-2 md:mb-4">
              <button
                onClick={() => setActiveTab("share")}
                className={`w-full border-b-[3px] md:border-b-[5px] rounded-[3px] md:rounded-[5px] ${
                  activeTab === "share" ? "border-[#152C24] text-[#152C24]" : "border-white"
                }`}
              />
              <button
                onClick={() => setActiveTab("embed")}
                className={`w-full border-b-[3px] md:border-b-[5px] rounded-[3px] md:rounded-[5px] ${
                  activeTab === "embed" ? "border-[#152C24] text-[#152C24]" : "border-white"
                }`}
              />
            </div>
            <div className="flex flex-col md:flex-row items-start justify-between mt-3 md:mt-6">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747088622/image_3_dxegw2.png"
                alt="map preview"
                className="w-full md:w-[270px] h-[80px] md:h-[140px] rounded-[3px] md:rounded-[5px] mb-2 md:mb-0"
              />
              <button className="text-[10px] md:text-[14px] font-bold self-end md:absolute md:bottom-6 md:right-6">
                {activeTab === "share" ? "COPY LINK" : "COPY HTML"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Location Modal - Mobile adjustments ONLY */}
      {isAddLocationOpen && (
        <div className="fixed inset-0 z-[999]  flex items-center justify-center bg-black/60 backdrop-blur-sm">
          <div className="bg-[#E7EBEB] w-[90%] max-w-[700px] md:w-[600px] p-4 md:p-12 rounded-md relative shadow-lg">
            <div className="flex justify-between items-center mb-2 md:mb-3">
              <h2 className="text-[16px] md:text-[24px] font-bold">Add Location</h2>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747088705/Dell_duotone_pdjxuz.png"
                alt="close"
                className="w-4 h-4 md:w-6 md:h-6 cursor-pointer"
                onClick={toggleAddLocationModal}
              />
            </div>

            <div className="mb-2 md:mb-3">
              <div className="flex justify-between items-center mb-1 md:mb-2">
                <span className="text-[14px] md:text-[20px] font-bold">Place details</span>
                <img 
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747090691/Expand_down_2_zw3io3.png" 
                  alt="expand" 
                  className="w-4 h-4 md:w-6 md:h-6 md:mr-10" 
                />
              </div>

              <p className="text-[12px] md:text-[16px] font-normal mb-1">Information about place</p>
              <input
                type="text"
                placeholder="Name of place required"
                className="w-full h-[40px] md:h-[66px]  border-white placeholder-black rounded-[3px] md:rounded-[5px] px-2 md:px-3 mb-2 text-[12px] md:text-[16px]"
              />
              <input
                type="text"
                placeholder="Value chain"
                className="w-full h-[40px] md:h-[60px]  border-white placeholder-black  rounded-[3px] md:rounded-[5px] px-2 md:px-3 mb-2 text-[12px] md:text-[16px]"
              />

              <p className="text-[12px] md:text-[16px] font-normal mb-1">Address</p>
              <input
                type="text"
                placeholder="XXXXXXXXX"
                className="w-full h-[40px] md:h-[60px] border-white placeholder-black  rounded-[3px] md:rounded-[5px] px-2 md:px-3 mb-2 text-[12px] md:text-[16px]"
              />

              <div className="relative mb-3">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747088622/image_3_dxegw2.png"
                  alt="map preview"
                  className="w-full h-[120px] md:h-[200px] rounded-[3px] md:rounded-md"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747086696/image_1737_lmlxuu.png"
                  alt="pin"
                  className="absolute top-[30%] left-[40%] w-6 h-6 md:w-[74px] md:h-[67px]"
                />
                <button 
                  className="absolute bottom-2 left-2 flex items-center gap-1 rounded-[3px] md:rounded-[5px] w-[100px] md:w-[145px] h-[25px] md:h-[35px] px-2 text-[10px] md:text-[14px] text-white font-medium"
                  style={{
                    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #152C24',
                    mixBlendMode: 'screen',
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)'
                  }}
                >
                  Edit location
                  <img 
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747090857/Edit_fill_lkeoca.png" 
                    alt="edit" 
                    className="w-3 h-3 md:w-4 md:h-4" 
                    style={{ filter: 'brightness(0) invert(1)' }}
                  />
                </button>
              </div>

              <div className="flex justify-end ">
                <button className="bg-[#FFBD26] text-white w-[80px] md:w-[130px] h-[30px] md:h-[40px] rounded-l-[5px] md:rounded-l-[10px] text-[10px] md:text-[14px] font-bold">
                  Cancel
                </button>
                <button className="bg-[#152C24] text-white w-[80px] md:w-[130px] h-[30px] md:h-[40px] rounded-r-[5px] md:rounded-r-[10px] text-[10px] md:text-[14px] font-bold">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Distance Modal - Mobile adjustments ONLY */}
      {showDistanceModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-[90%] max-w-[700px] md:w-[600px] h-[400px] md:h-[700px] bg-white rounded-md overflow-hidden shadow-lg">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747093830/Dell_duotone_k4qo64.png"
              alt="close"
              className="absolute top-2 right-2 md:top-6 md:right-4 w-6 h-6 md:w-12 md:h-12 cursor-pointer z-50"
              onClick={toggleDistanceModal}
            />

            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747094364/image_4_t9ntqe.png"
              alt="Distance Map"
              className="w-full h-full object-cover"
            />

            <div
              className="absolute top-20 right-3 md:top-36 md:right-6 text-white text-[10px] md:text-[14px] font-normal px-3 py-1 md:px-6 md:py-2 rounded-md z-40"
              style={{ backgroundColor: '#152C24', mixBlendMode: 'screen' }}
            >
              Drag to change
            </div>

            <div className="absolute right-[15%] top-[25%] h-[150px] md:h-[255px] w-0 border-l-[3px] md:border-l-[5px] border-dashed border-white rotate-[25deg] z-30"></div>

            <div className="absolute right-[12%] top-[35%] text-white text-[10px] md:text-[14px] font-bold transform rotate-[-65deg] z-30">
              100Kms
            </div>

            <div className="absolute bottom-2 left-2 md:bottom-4 md:left-14 w-[calc(100%-16px)] md:w-[480px] h-[80px] md:h-[133px] bg-[#E7EBEB] rounded-[3px] md:rounded-[5px] px-2 md:px-4 py-1 md:py-2">
              <p className="text-[14px] md:text-[20px] font-bold">Measure distance</p>
              <p className="text-[10px] md:text-[16px] mt-1 md:mt-3">Click to measure distance</p>
              <p className="text-[14px] md:text-[20px] font-bold mt-2 md:mt-4">Total Distance : 100Kms</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}